// 新增藥物component

<template lang="pug">
div
  div.row.upper-subpanel
    progressBar
    div.upper-subpanel--without-progressbar
      scanBarcode(v-if="stage === 'scanBarcode'" v-on:setBarcode="getBarcode")
      selectDrug(v-if="stage === 'selectDrug'")
      SplitLayout(v-if="stage === 'selectPosition'")
        DrugInfo(slot="left")
        SelectBox(slot="right" :mode="'emptyAndF'")
      MultiFlow(v-if="stage === 'setFlowData'" 
        v-on:setAllConfirmData="getAllConfirmData" 
        :multiProgress="multiProgress" 
        :confirmProgress="confirmProgress")
      Loader(v-if="stage === 'finishAddDrug'")
  BottomButtons
    action-button(title="回主畫面" slot="button-1" @click.native="cancel")
    action-button(title="全部藥物" slot="button-5" @click.native="stage = 'selectDrug'" v-if="stage === 'scanBarcode' || stage === 'selectDrug'")
    action-button(title="掃描條碼" slot="button-6" @click.native="stage = 'scanBarcode'" v-if="stage === 'scanBarcode' || stage === 'selectDrug'")
    action-button(title="確認位置" slot="button-9" @click.native="confrimPosition" v-if="stage === 'selectPosition'")
  
</template>

<script>
import ProgressBar from './flowComp/ProgressBar';
import ScanBarcode from './flowComp/ScanBarcode';
import SelectBox from './flowComp/PositionSelection';
import SelectDrug from './flowComp/DrugSelection';
import UpDownPanel from './flowComp/UpDownPanel';
import MultiFlow from './CreateDrugFlow/MultiFlow';
import BottomButtons from './common/BottomButtons';
import Loader from './common/Loader';
import DrugInfo from './flowComp/DrugInfo';
import SplitLayout from './SplitLayout';
import AppBase from './ComponentBase/AppBase';

export default {
  name: 'AddNewDrug',
  extends: AppBase,
  data() {
    return {
      stage: 'scanBarcode',
    };
  },
  components: {
    ProgressBar,
    SelectBox,
    SelectDrug,
    MultiFlow,
    ScanBarcode,
    Loader,
    DrugInfo,
    BottomButtons,
    SplitLayout,
  },
  created() {
    this.stage = 'scanBarcode';
    this.progress = [
      { en: 'selectDrug', zh: '選擇藥物' },
      { en: 'selectPosition', zh: '選擇位置' },
      { en: 'setMaxStock', zh: '最大庫存' },
      { en: 'setExpiredDate', zh: '有效期限' },
      { en: 'action', zh: '儲存藥物' },
      { en: 'setMinStorage', zh: '安全庫存' },
    ];
    this.multiProgress = ['confirm', 'setMinStorage'];
    this.confirmProgress = ['setMaxStock', 'setExpiredDate', 'action'];
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
  },
  computed: {
    selectedDevices() {
      return this.$store.state.device.selectedDevices;
    },
    selectDrug() {
      return this.$store.state.drug.selectedDrug;
    },
  },
  methods: {
    confrimPosition() {
      if (Object.keys(this.selectedDevices).length !== 0) {
        this.stage = 'setFlowData';
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請至少選擇一個藥盒',
        });
      }
    },
    async getAllConfirmData() {
      this.$store.dispatch('resetAll');
      this.$store.dispatch('getSystemInfo');
      this.$store.dispatch('getDrugInDevices');
      this.stage = 'scanBarcode';
      this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
    },
    getBarcode(data) {
      this.instance.get(`/api/medication/?package_code2=${data}`).then((res) => {
        if (res.data.results.length === 0) {
          this.instance.get(`/api/medication/?package_code=${data}`).then((res) => {
            if (res.data.results.length === 0) {
              this.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '查無此藥',
              });
            } else {
              this.$store.dispatch('setDrug', res.data.results[0].id);
              this.stage = 'selectPosition';
            }
          });
        } else {
          this.$store.dispatch('setDrug', res.data.results[0].id);
          this.stage = 'selectPosition';
        }
      });
    },
    cancel() {
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_LOAD' });
      this.$router.push({ name: 'Main' });
    },
  },
  watch: {
    selectDrug(val) {
      if (val) this.stage = 'selectPosition';
    },
    stage(val) {
      if (val === 'scanBarcode') {
        this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
      } else {
        this.$store.commit('SET_CURRENT_STEP', val);
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// CreateDrug.vue?d96cacb8